var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePptx = function SvgFilePptx(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M7.8.6h8.67c1.103 0 2.162.434 2.948 1.208l7.728 7.609A4.2 4.2 0 0 1 28.4 12.41V27.2a4.2 4.2 0 0 1-4.2 4.2H7.8a4.2 4.2 0 0 1-4.2-4.2V4.8A4.2 4.2 0 0 1 7.8.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E4E8EF",
    strokeWidth: 1.2,
    d: "M18 1v6.8a3.2 3.2 0 0 0 3.2 3.2H28"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D97706",
    d: "M0 17a3 3 0 0 1 3-3h19a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.47 21.152V23H3.434v-5.026h2.065c1.155 0 1.876.546 1.876 1.589 0 1.036-.721 1.589-1.876 1.589zm0-.875h.973c.602 0 .91-.266.91-.714 0-.455-.308-.714-.91-.714H4.47zm4.61.875V23H8.046v-5.026h2.065c1.155 0 1.876.546 1.876 1.589 0 1.036-.721 1.589-1.876 1.589zm0-.875h.974c.602 0 .91-.266.91-.714 0-.455-.308-.714-.91-.714H9.08zm7.432-1.414h-1.575V23h-1.036v-4.137h-1.575v-.889h4.186zm4.907-.889-1.666 2.471L21.496 23h-1.169l-1.19-1.792L17.933 23h-1.127l1.743-2.555-1.68-2.471h1.162l1.127 1.694 1.134-1.694z"
  })));
};
export default SvgFilePptx;